import { ClientSettingName, IClientSettings, IOCAPIError, IUserAppSettings } from "@vmosolutions/oc-interfaces";
import AmplifyAPIWrapper from "src/API/AmplifyAPIWrapper";
import { Alert } from "src/redux/state/Alert";
import { Spinner } from "src/redux/state/Spinner";
import { User } from "src/redux/state/User";
import { Utility } from "src/redux/state/Utility";
import { IMosaicTabNode } from "src/utils/MosaicTree";
import { IRootModalState } from "../reducers/ModalReducer";
import { ISnackbarState } from "../reducers/SnackbarReducer";
import { IStructuresState } from "../reducers/StructuresReducer";
import { ActionType, appSettings, IAppAction } from "./Helpers";

type IOpenWindow = (
  title: string,
  componentName: string,
  path: string[],
  props: any,
  windowType: "content" | "context" | "singleContext",
  focusExisting?: boolean
) => any;

export interface IApplicationProps {
  openWindow: IOpenWindow;
  openDrawer: () => IAppAction;
  closeDrawer: () => IAppAction;
  showPopup: (alert: Alert) => IAppAction;
  closePopup: () => IAppAction;
  showSpinner: (message: string) => IAppAction;
  hideSpinner: () => IAppAction;
  login: (data: any) => IAppAction;
  logout: () => IAppAction;
  createUser: (content: any) => any;
  getUser: (id: any) => any;
  updateUser: (context: any) => any;
  deleteUser: (context: any) => any;
  appendNodeToFirstValidLeaf: (tabNode: IMosaicTabNode) => any;
  match: any;
  location: any;
  history: any;
  utility: Utility;
  authentication: User;
  structures: IStructuresState;
  users: any;
  locales: any;
  setLocales: (payload: any) => any;
  updateLocale: (payload: any) => any;
  setTheme: (payload: string) => any;
  ToggleUIDS: (payload: boolean) => any;
  toggleDashboardWindow: () => any;
  toggleSettingsWindow: () => any;
  toggleMosaicWindow: (windowId: any, toggleStateStr: string, toggleType: any) => any;
  openSnackbar: (payload: ISnackbarState) => IAppAction;
  closeSnackbar: () => IAppAction;
  openModal: (payload: IRootModalState) => IAppAction;
  closeModal: (payload: IRootModalState) => IAppAction;
}

export const ToggleUIDS = (payload: boolean): IAppAction => {
  return { type: ActionType.TOGGLE_UIDS, payload };
};

export const setTheme = (payload: string): IAppAction => {
  return { type: ActionType.SET_THEME, payload };
};

export const openSnackbar = (payload: ISnackbarState): IAppAction => {
  return { type: ActionType.OPEN_SNACKBAR, payload: payload };
};

export const closeSnackbar = (): IAppAction => {
  return { type: ActionType.CLOSE_SNACKBAR };
};

export const openModal = (payload: IRootModalState): IAppAction => {
  return { type: ActionType.OPEN_MODAL, payload: payload };
};

export const closeModal = (payload: IRootModalState): IAppAction => {
  return { type: ActionType.CLOSE_MODAL, payload: payload };
};

export const openDrawer = (): IAppAction => {
  return {
    type: ActionType.OPEN_DRAWER,
  };
};

export const closeDrawer = (): IAppAction => {
  return {
    type: ActionType.CLOSE_DRAWER,
  };
};

export const showPopup = (data: Alert): IAppAction => {
  return {
    type: ActionType.OPEN_ALERT,
    payload: data,
  };
};

export const closePopup = (): IAppAction => {
  return {
    type: ActionType.CLOSE_ALERT,
  };
};

export const showSpinner = (message: string): IAppAction => {
  return {
    type: ActionType.OPEN_SPINNER,
    payload: new Spinner({ message }),
  };
};

export const hideSpinner = (): IAppAction => {
  return {
    type: ActionType.CLOSE_SPINNER,
  };
};

export const login = (data: any): IAppAction => {
  return { type: ActionType.LOGIN_REQUEST, payload: data };
};

export const logout = (): IAppAction => {
  return { type: ActionType.LOGOUT_REQUEST };
};

/** Pass in appSettings to update in redux, optional paramters contains the specific appSetting you want updated */
export const updateUserAppSettings = (settings: IUserAppSettings, updateOnly?: appSettings): IAppAction => {
  return { type: ActionType.UPDATE_USER_APP_SETTINGS, payload: settings, updateOnly: updateOnly };
};

export const getClientSetting = async (settingName: ClientSettingName | string): Promise<IClientSettings | null> => {
  if (settingName) {
    const response: IClientSettings | IOCAPIError | null = await AmplifyAPIWrapper.Get<IClientSettings>(
      `/clientSettings?settingName=${settingName}`
    );
    return response;
  } else return null;
};
